
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

import { List, Toast } from 'vant';
import { getList, backList } from '../api';
import SearchBar from './SearchBar.vue';
import Item from './Item.vue';
Vue.use(List);
@Component({
  components: {
    SearchBar,
    Item,
  },
})
export default class VoteList extends Vue {
  @Prop({ default: 1 }) id!: number;
  page = 1;
  loading = false;
  finished = false;
  loadingStatus = true;
  refreshing: boolean = false;
  placeholder: string = '请输入作者或作品名称';
  inputText: string = '';
  voteList: any[] = [];
  word = '';
  show: boolean = true;
  @Watch('id')
  handleSearch(newval: any, oldval: any) {
    this.resetState();
  }
  resetState() {
    this.loading = false;
    this.finished = false;
    this.voteList = [];
    this.page = 1;
    this.show = false;
    setTimeout(() => {
      this.show = true;
    }, 500);
  }
  clear() {
    this.resetState();
  }
  onSearch() {
    this.resetState();
  }
  userInputChange(text: string) {
    this.inputText = text;
  }
  onLoad() {
    console.log(this.page, this.inputText);
    getList(this.page, this.inputText).then((res: any) => {
      console.log('res:', res);
      this.endListData(res);
    });
  }
  endListData(res: any) {
    if (!res.data || res.data.length === 0) {
      this.finished = true;
    } else {
      this.voteList = [...this.voteList, ...res.data];
    }
    this.page = this.page + 1;
    this.loading = false;
  }
  goDetail(id: string) {
    this.$router.push(`detail?id=${id}`);
  }
  clickItem(item: any) {
    this.$router.push({
      path: 'detail',
      query: {
        id: item.id,
        tb: item.tb,
      },
    });
  }
}
